module.exports = __webpack_public_path__ + "img/28-l.01a53fa6.png";